// extracted by mini-css-extract-plugin
export default {"certificate-empty-icon":"certificate-empty-icon__6nnaX"};